import React from 'react'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as PoziUtils from 'api/utils'
import { setLayerFilter } from 'drawer/tabs/layers/actions'
import LayerFilterValueSelect from 'drawer/tabs/layers/filter/LayerFilterValueSelect'
import PoziMap from 'map/map'

// .MuiFormLabel-root-66.MuiFormLabel-focused-67
// https://material-ui.com/demos/text-fields/#customized-inputs
const styles = theme => ({
  root: {
    paddingRight: 4,
    paddingBottom: 10
  },
  main: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  select: {},
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '250px',
    'text-align': 'left',
    'margin-left': 0,
    'padding-left': 0,
    'border-left': 0
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  cssLabel: {
    'font-weight': 'normal',
    '&$cssFocused': {
      color: '#424242'
    }
  },
  cssFocused: {}
})

class LayerFilterPropSelect extends React.Component {
  constructor (props) {
    super(props)
    const { layerPropsFilter } = props
    if (layerPropsFilter && layerPropsFilter.prop) {
      this.state = {
        selectedProp: layerPropsFilter.prop
      }
    } else {
      this.state = {
        selectedProp: ''
      }
    }
  }

  componentDidMount () {
    const { geojson } = this.props
    this.setState({ geojson })
  }

  handleChange = (event) => {
    const { titleid, layerConf, setLayerFilter } = this.props

    console.debug('LayerFilterPropSelect - handleChange', event.target.name, event.target.value)

    this.setState({ [event.target.name]: event.target.value })

    let newPropsFilter = null

    // If a category is selected, set the value and clear the value field underneath it
    if (event.target.value !== '(None)') {
      newPropsFilter = {
        prop: event.target.value,
        value: ''
      }
    }

    // console.debug('handleChange filter', propsFilter)

    setLayerFilter(titleid, newPropsFilter)

    // Update map
    PoziMap().showFeaturesInLayer(layerConf, newPropsFilter?.prop, newPropsFilter?.value)
  }

  render () {
    const { classes, titleid, layerAttributes, layerPropsFilter, layerSelected, layerVisible, selectValues, geojson } = this.props

    const { selectedProp } = this.state

    if (!selectValues || selectValues.length === 0 || !geojson || !titleid) {
      console.log('render - No selectValues, geojson or titleid. Not rendering.', titleid, selectValues, geojson)
      return null
    }

    // console.debug('LayerFilterPropSelect - render', titleid, layerSelected, layerVisible)

    if (!layerSelected && !layerVisible) {
      const layerConf = window.store.getState().layers[titleid]
      console.log('render - layer not selected. Not rendering.', titleid, layerConf)
      return null
    }

    const noneKey = 'layers-filter-select-options-none-' + titleid
    const menuItemArr = []
    menuItemArr.push(
      <MenuItem key={noneKey} value="(None)">
        <em>(None)</em>
      </MenuItem>
    )

    let sortedArr = selectValues.sort()
    sortedArr = PoziUtils.removeExcludedPropertiesFromArray(sortedArr)
    for (const [index, value] of sortedArr.entries()) {
      const key = 'layers-filter-select-options-' + titleid + '-' + index

      // Use field alias as label instead of value if provided in attributes
      const label = layerAttributes?.[value]?.alias || value

      const labelDisplay = startCase(toLower(label))
      menuItemArr.push(
        <MenuItem key={key} value={value}>
          <em>{labelDisplay}</em>
        </MenuItem>
      )
    }

    const id = 'layers-filter-select-options-' + titleid

    return (
      <div className="pozi-layer-filter-prop-select">
        <div className={classes.root}>
          <form className={classes.main} noValidate autoComplete="off">
            <FormControl className={classes.formControl}>
              <InputLabel
                shrink
                classes={{
                  root: classes.cssLabel,
                  focused: classes.cssFocused
                }}
                className={classes.inputLabel}
                htmlFor={id}
              >
                Category...
              </InputLabel>
              <Select
                className={classes.select}
                value={selectedProp}
                onChange={this.handleChange}
                displayEmpty
                inputProps={{
                  name: 'selectedProp',
                  id
                }}
              >
                {menuItemArr}
              </Select>
            </FormControl>
          </form>
          <LayerFilterValueSelect titleid={titleid} selectedProp={selectedProp} geojson={geojson} />
        </div>
      </div>
    )
  }
}

LayerFilterPropSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  geojson: PropTypes.object,
  layerAttributes: PropTypes.object,
  layerConf: PropTypes.object,
  layerPropsFilter: PropTypes.object,
  layerSelected: PropTypes.bool,
  layerVisible: PropTypes.bool.isRequired,
  selectValues: PropTypes.array,
  setLayerFilter: PropTypes.func.isRequired,
  titleid: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const layerConf = state.layers[ownProps.titleid] ?? {}
  const layerPropsFilter = layerConf.propsFilter ?? null
  const layerSelected = layerConf.selected ?? null
  const layerVisible = layerConf.visible ?? null
  const layerAttributes = layerConf.attributes

  return {
    layerAttributes,
    layerConf,
    layerPropsFilter,
    layerSelected,
    layerVisible
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLayerFilter: (titleid, propsFilter) => {
      dispatch(setLayerFilter(titleid, propsFilter))
    }
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LayerFilterPropSelect)
)
